import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconDragAndDrop = styled.img.attrs({
  src: "/assets/images/icon-dragdrop.svg"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconDragAndDrop.displayName = "IconDragAndDrop";

export default IconDragAndDrop;
